import { render, staticRenderFns } from "./featured-agent.vue?vue&type=template&id=9f46e818"
import script from "./featured-agent.vue?vue&type=script&lang=js"
export * from "./featured-agent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports